import React, { useState } from 'react';
import { Modal, Button, Paper, withStyles } from '@material-ui/core';
import iconClient from './images/iconClient.png';

const styles = {
  modalStyle: {
    position: 'absolute',
    width: 450,
    height: 500,
    top: 100,
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: 'white',
    borderRadius: 24,
    padding: '25px',
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center'
  }
};

const ModalNoPendingReceipts = ({ classes, open, setOpen }) => {
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <Paper className={classes.modalStyle}>
          <img src={iconClient} alt="Icono de cliente" style={{ width: '100px', height: '100px' }} />
          <span
            style={{ fontFamily: 'Sura Sans', fontSize: '22px', color: '#0033A0', fontWeight: 600, marginTop: '10px' }}
          >
            Sin recibos pendientes
          </span>
          <span style={{ fontFamily: 'Sura Sans', fontSize: '16px', color: '#0033A0', textAlign: 'center', marginTop: '10px' }}>
            La póliza consultada no tiene recibos pendientes por mostrar en este momento
          </span>
          <span style={{ fontFamily: 'Sura Sans', fontSize: '16px', color: '#0033A0', textAlign: 'center', marginTop: '2px' }}>
            Si tienes dudas comunícate con nosotros:
          </span>
          <span style={{ fontFamily: 'Sura Sans', fontSize: '16px', color: '#0033A0', textAlign: 'center', marginTop: '2px' }}>
            Teléfono: 55 5723 7946
          </span>
          <span style={{ fontFamily: 'Sura Sans', fontSize: '16px', color: '#0033A0', textAlign: 'center', marginTop: '2px' }}>
            <b>Correo:</b> <span style={{ textDecoration: 'underline' }}> atencion.cobranza@segurossura.com.mx</span>
          </span>
          <span style={{ fontFamily: 'Sura Sans', fontSize: '16px', color: '#0033A0', textAlign: 'center', marginTop: '2px' }}>
            <b>Horario de servicio:</b> lunes a viernes de 8:00 a 20:00 horas y sábado de 09:00 a 15:00 horas
          </span>
          <div
            onClick={handleClose}
            style={{
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '92px',
              height: '40px',
              borderRadius: '28px',
              border: '1px solid #0133A0',
              fontFamily: 'Sura Sans',
              fontSize: '16px',
              color: '#0133A0',
              justifySelf:'flex-end',
              marginTop: '27px'
            }}
          >
            Aceptar
          </div>
        </Paper>
      </Modal>
    </div>
  );
};

export default withStyles(styles)(ModalNoPendingReceipts);



// WEBPACK FOOTER //
// ./src/containers/client/ModalNoPendingReceipts.js